import { Component } from '@angular/core';

@Component({
  selector: 'app-licenses-layout',
  template: `
    <div class="overview__layout">
      <div class="overview__overview">
        <app-licenses></app-licenses>
      </div>
      <div class="overview__sidepanel">
        <app-license-sidepanel></app-license-sidepanel>
      </div>
    </div>
  `,
})
export class LicensesLayoutComponent {}
